import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

type AppSettingsStore = {
  hasActiveSoftphoneCalls: boolean;
  setHasActiveSoftphoneCalls: (hasActiveCall: boolean) => void;
  setLastRegisteredCallId: (callId: string) => void;
  lastRegisteredCallId: string;
  setSoftphoneHasRegistered: (softphoneHasRegistered: boolean) => void;
  softphoneHasRegistered: boolean;
};

/* 
  hasActiveSoftphoneCalls: detects when there is an active softphone call happening
  lastRegisteredCallId: stores the last registered call id
  softphoneHasRegistered: detects if the softphone has ever registered on the current browser 
*/

export const useAppSettingsStore = createStoreWithSubscribe<AppSettingsStore>(
  (set) => ({
    hasActiveSoftphoneCalls: false,
    setHasActiveSoftphoneCalls: (hasActiveSoftphoneCalls) => set({ hasActiveSoftphoneCalls }),
    lastRegisteredCallId: '',
    setLastRegisteredCallId: (lastRegisteredCallId) => set({ lastRegisteredCallId }),
    setSoftphoneHasRegistered: (softphoneHasRegistered) => set({ softphoneHasRegistered }),
    softphoneHasRegistered: false,
  }),
  {
    name: 'AppSettingsStore',
    trace: true,
  }
);

export const useAppSettingsShallowStore = createShallowStore(useAppSettingsStore);
